import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BurguerButton from './BurguerButton';
import LanguageSwitcher from './ui/LanguageSwitcher';
import SearchAutocomplete from './SearchAutocomplete'; // Import the new component

function Navbar() {
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setClicked(!clicked);
  };

  const handleCloseMenu = () => {
    setClicked(false);
  };

  const handleRouteSelection = (route) => {
    navigate(route);
    handleCloseMenu();
  };

  return (
    <>
      <NavContainer>
        <div className="nav-content">
          <h2>
            Maderas Estufadas del Guadiana <span></span>
          </h2>
          <div className={`links ${clicked ? 'active' : ''}`}>
            <Link onClick={handleCloseMenu} to="/home">Home</Link>
            <Link onClick={handleCloseMenu} to="/about">About</Link>
            <Link onClick={handleCloseMenu} to="/products">Products</Link>
            <Link onClick={handleCloseMenu} to="/contact">Contact</Link>
            <div className="search-bar">
              <SearchAutocomplete onSelectRoute={handleRouteSelection} />
            </div>
            <Link onClick={handleCloseMenu} to="/login" className="login-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                <path
                  fillRule="evenodd"
                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                />
              </svg>
            </Link>
            <LanguageSwitcher />
          </div>
          <div className="burguer">
            <BurguerButton clicked={clicked} handleClick={handleClick} />
          </div>
        </div>
      </NavContainer>
    </>
  );
}

export default Navbar;

const NavContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #697565;

  .nav-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem;
    position: relative;
  }

  h2 {
    color: white;
    font-weight: 400;
    span {
      font-weight: bold;
    }
  }

  .links {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    flex-grow: 1;

    a {
      color: white;
      font-size: 1rem;
      text-decoration: none;
    }

    .search-bar {
      input {
        padding: 5px;
        font-size: 1rem;
        border-radius: 5px;
        border: none;
        outline: none;
      }
    }

    .login-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.5rem;
      color: white;
      text-decoration: none;

      svg {
        width: 24px;
        height: 24px;
      }
    }

    @media (max-width: 700px) {
      display: none;
    }
  }

  .links.active {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #697565;
    z-index: 999;
    padding-top: 4rem;
    text-align: center;

    a,
    .search-bar,
    .login-icon {
      margin-top: 1rem;
      display: block;
      color: white;
    }

    .search-bar {
      input {
        width: 80%;
        margin: 0 auto;
      }
    }
  }

  .burguer {
    display: block;
    @media (min-width: 700px) {
      display: none;
    }
  }
`;
